define.alias("shared/components/shared/credentials/password-input", "settings/components/shared/credentials/password-input");